<div
    *ngIf="isLoading"
    style="
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        background-color: rgba(0, 0, 0, 0.2);
        z-index: 99999;
    ">
    <mat-progress-bar
        mode="indeterminate"
        color="warn"
        style="position: absolute; top: 0px; left: 0px; right: 0px; z-index: 99999">
    </mat-progress-bar>
</div>
<div style="width: 100%; height: 100%; background: #a0a0a0">
    <lib-mimic-viewer
        *ngIf="showMimicViewer()"
        [mimic]="selectedMimic"
        [width]="maxWidth"
        [height]="maxHeight"
        [elementsSettings]="elementsSettings"
        [elementIntegrations]="elementIntegrations"
        [channelsUpdateObservable]="channelsUpdateObservable"
        [updatedChannelObservable]="updatedChannelObservable"
        [defaultColors]="defaultColors"
        [vesselId]="vesselId"
        [channelList]="channelList"
        (createLibraryComponentElement)="createLibraryComponentElement($event)">
    </lib-mimic-viewer>
</div>
